 <div class="dialog-container">
    <div class="dialog-title-block">
        <h2> {{ cabinet.type === 'u_name' ? "Edit Cabinet Unique Name" : "Minimum Order Quantity" }} </h2>
        <div class="dialog-colse-btn" (click)="onClose()">
            <img src="../../../assets/images/close.png" alt="close">
        </div>
    </div>
    <form #f="ngForm" name="form" (ngSubmit)="f.form.valid && editCabinet(f.value)" novalidate>
        <div class="dialog-content-block" *ngIf="cabinet.type === 'u_name'">
            <div>
                <p>This Cabinet Unique Name will be used across the product for identification.</p>
            </div>
            <div class="content d-flex flex-column">
                <label for="" class="mb-2">Cabinet Unique Name</label>
                <input type="text" placeholder="Cabinet Unique Name" #cabinetname="ngModel" [(ngModel)]="cabinet.name" name="u_name" required>
                <span *ngIf="f.submitted && cabinetname.errors?.required" class="text-xs text-missing">Cabinet name is required</span>         
                <span *ngIf="errorMessage ===''" class="warning-msg">Only Character, Numbers and Special character allowed</span>         
                <span *ngIf="errorMessage !==''" class="text-xs text-missing">{{ errorMessage }}</span>         
            </div>
        </div>
        <div class="dialog-content-block" *ngIf="cabinet.type !== 'u_name'">
            <div>
                <p>Low Stock Notification and alert will be sent to the respective user if the stock count goes below the defined value</p>
            </div>
            <div class="content d-flex align-items-center">
                <label for="">Cabinet:</label>         
                <span class="fw-bold">{{ cabinet.name }}</span>
            </div>
            <div class="content">
                <div class="d-flex align-items-center">
                    <label for="" class="mb-2">Minimum Order Quantity:</label>             
                    <div class="d-flex flex-column justify-content-end">
                        <input class="input-width-half" min="25" type="number" placeholder="" #quantity="ngModel" [(ngModel)]="cabinet.minimum_quantity" name="minimum_quantity" required>
                        <span *ngIf="f.submitted && quantity.errors?.required" class="text-xs text-missing">Minimum quantity order is required</span> 
                        <span *ngIf="f.submitted && quantity.errors?.min" class="text-xs text-missing">Least accepted value is 25</span> 
                        <span *ngIf="!(f.submitted && quantity.errors?.min) && errorMessage ===''" class="warning-msg">Least accepted value 25</span>         
                        <span *ngIf="errorMessage !==''" class="text-xs text-missing">{{ errorMessage }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <button type="button" (click)="onClose()">Cancel</button>
            <button type="submit">Update</button>
        </div>
    </form>  
</div>

